import { render, staticRenderFns } from "./ProgramareNoua.vue?vue&type=template&id=3e0fb611"
import script from "./ProgramareNoua.vue?vue&type=script&lang=js"
export * from "./ProgramareNoua.vue?vue&type=script&lang=js"
import style0 from "./ProgramareNoua.vue?vue&type=style&index=0&id=3e0fb611&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports